// This file is under queries to avoid tests.
// This is a very temporary file that will be removed
// once a proper fix is implemented.
import type { Product, ProductItem, ProductVariant } from '../types';

function isRelatedProductVariantProduct(
    item: (ProductItem | ProductVariant) & {
        variants?: { sku: string }[];
    }
): item is ProductVariant {
    return !item.sku && !item.variants;
}

export interface FixedProductItem extends ProductItem {
    selectedVariant?: ProductVariant & {
        variantSku?: string;
    };
}

export interface ProductWithFixedRelatedProducts extends Product {
    accessories: FixedProductItem[];
    spareParts: FixedProductItem[];
    relatedProducts: FixedProductItem[];
    alternativeProducts: FixedProductItem[];
    safetyDatasheetUrl?: string;
    hazardStatements?: string;
}

const processRelatedProducts = (
    product: Product
): ProductWithFixedRelatedProducts => {
    const relatedProductsMapFn = (items?: (ProductItem | ProductVariant)[]) =>
        items?.map(item =>
            isRelatedProductVariantProduct(item)
                ? {
                      ...(item.parent as ProductItem),
                      sku: item.variantSku,
                      variants: [],
                  }
                : item
        ) ?? [];

    return {
        ...product,
        accessories: relatedProductsMapFn(product.accessories),
        spareParts: relatedProductsMapFn(product.spareParts),
        relatedProducts: relatedProductsMapFn(product.relatedProducts),
        alternativeProducts: relatedProductsMapFn(product.alternativeProducts),
    };
};

export default processRelatedProducts;
